import type { PaletteOptions } from '@mui/material/styles'
import * as common from '@mui/material/colors'
import { omit, assign } from 'maeng-utils/utils'
import * as colors from './colors'

/**
 * 컴포넌트의 color props로 전달되어 사용되는 색상으로, main, contrastText 등의 필드가 포함된 객체
 * 스타일에서는 theme.palette.primary.main 형태로 사용할 수 있습니다.
 */
export const colorPropsSet = {
  primary: {
    main: colors.pink[500],
    refer: colors.pink,
  },
  secondary: {
    main: colors.gray[700],
    refer: colors.gray,
  },
  accent: {
    main: colors.geekblue[600],
    contrastText: '#fff',
    refer: colors.geekblue,
  },
  info: {
    main: colors.blue[500],
    refer: colors.blue,
  },
  warning: {
    main: colors.orange[500],
    refer: colors.orange,
  },
  error: {
    main: colors.red[500],
    refer: colors.red,
  },
  success: {
    main: colors.green[600],
    refer: colors.green,
  },
  black: {
    main: '#000',
    contrastText: '#fff',
  },
  white: {
    main: '#fff',
    contrastText: 'rgba(0, 0, 0, 87%)',
  },
  red: {
    main: colors.red[500],
    contrastText: '#fff',
    refer: colors.red,
  },
  volcano: {
    main: colors.volcano[500],
    contrastText: '#fff',
    refer: colors.volcano,
  },
  orange: {
    main: colors.orange[500],
    contrastText: '#fff',
    refer: colors.orange,
  },
  gold: {
    main: colors.gold[500],
    contrastText: '#fff',
    refer: colors.gold,
  },
  yellow: {
    main: colors.yellow[500],
    contrastText: '#fff',
    refer: colors.yellow,
  },
  lime: {
    main: colors.lime[500],
    contrastText: '#fff',
    refer: colors.lime,
  },
  green: {
    main: colors.green[500],
    contrastText: '#fff',
    refer: colors.green,
  },
  cyan: {
    main: colors.cyan[500],
    contrastText: '#fff',
    refer: colors.cyan,
  },
  blue: {
    main: colors.blue[500],
    contrastText: '#fff',
    refer: colors.blue,
  },
  geekblue: {
    main: colors.geekblue[500],
    contrastText: '#fff',
    refer: colors.geekblue,
  },
  purple: {
    main: colors.purple[500],
    contrastText: '#fff',
    refer: colors.purple,
  },
  pink: {
    main: colors.pink[500],
    contrastText: '#fff',
    refer: colors.pink,
  },
  gray: {
    main: colors.gray[500],
    contrastText: '#fff',
    refer: colors.gray,
  },
} as const

const palette: PaletteOptions = {
  ...colorPropsSet,
  /**
   * 컬러 팔레트 형태로 사용되는 생상으로, { 100: ..., 200: ... } 형태의 객체
   * 스타일에서는 theme.palette.red[500] 형태로 사용할 수 있습니다.
   */

  /** @types에 타입 확장 */
  common: assign({}, omit(common, 'common'), colors),
}

export default palette
